import { render, staticRenderFns } from "./j29fj1.vue?vue&type=template&id=a5f95724&scoped=true&"
import script from "./j29fj1.vue?vue&type=script&lang=js&"
export * from "./j29fj1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f95724",
  null
  
)

export default component.exports